import lodashImport from 'lodash/lodash.js';

type LoDashStatic = typeof lodashImport extends {default: infer M} ? M : typeof lodashImport;

/** Unwrap CJS default interop so chain calls like _(x).map(...) work under ESM. */
const _: LoDashStatic = ((lodashImport as {default?: LoDashStatic}).default ?? lodashImport) as LoDashStatic;

export {_};
export default _;

export {default as isFunction} from 'lodash/isFunction.js';
export {default as isNaN} from 'lodash/isNaN.js';
export {default as parseInt} from 'lodash/parseInt.js';
